module.exports = {
  chart: {
    normal: {
      effective: [],
      notEffective: ['rock', 'ground', 'steel']
    },
    fire: {
      effective: ['grass', 'ice', 'bug', 'steel'],
      notEffective: ['fire', 'water', 'rock', 'dragon']
    },
    water: {
      effective: ['fire', 'ground', 'rock'],
      notEffective: ['water', 'grass', 'dragon']
    },
    electric: {
      effective: ['water', 'flying'],
      notEffective: ['electric', 'grass', 'ground', 'dragon']
    },
    grass: {
      effective: ['water', 'ground', 'rock'],
      notEffective: ['fire', 'grass', 'poison', 'flying', 'bug', 'dragon']
    },
    ice: {
      effective: ['grass', 'ground', 'flying', 'dragon'],
      notEffective: ['fire', 'water', 'ice', 'steel']
    },
    fighting: {
      effective: ['normal', 'ice', 'rock', 'dark', 'steel'],
      notEffective: ['poison', 'flying', 'psychic', 'bug', 'fairy']
    },
    poison: {
      effective: ['grass', 'fairy'],
      notEffective: ['poison', 'ground', 'rock', 'ghost', 'steel']
    },
    ground: {
      effective: ['fire', 'electric', 'poison', 'rock', 'steel'],
      notEffective: ['grass', 'flying', 'bug']
    },
    flying: {
      effective: ['grass', 'fighting', 'bug'],
      notEffective: ['electric', 'rock', 'steel']
    },
    psychic: {
      effective: ['fighting', 'poison'],
      notEffective: ['psychic', 'dark', 'steel']
    },
    bug: {
      effective: ['grass', 'psychic', 'dark'],
      notEffective: ['fire', 'fighting', 'poison', 'flying', 'ghost', 'steel', 'fairy']
    },
    rock: {
      effective: ['fire', 'ice', 'flying', 'bug'],
      notEffective: ['fighting', 'ground', 'steel']
    },
    ghost: {
      effective: ['psychic', 'ghost'],
      notEffective: ['normal', 'dark']
    },
    dragon: {
      effective: ['dragon'],
      notEffective: ['steel', 'fairy']
    },
    dark: {
      effective: ['psychic', 'ghost'],
      notEffective: ['fighting', 'dark', 'fairy']
    },
    steel: {
      effective: ['ice', 'rock', 'fairy'],
      notEffective: ['fire', 'water', 'electric', 'steel']
    },
    fairy: {
      effective: ['fighting', 'dragon', 'dark'],
      notEffective: ['fire', 'poison', 'steel']
    }
  },
  calc: function( defending, attacking ) {
    const chart = this.chart;
    var effectiveness = 0;

    if( typeof defending === 'string' ) {
      defending = new Array(defending);
    }

    defending.forEach(function(type) {
      if( chart[attacking.toLowerCase()]['effective'].indexOf(type.toLowerCase()) > -1 ) {
        effectiveness += 1;
      } else if( chart[attacking.toLowerCase()]['notEffective'].indexOf(type.toLowerCase()) > -1 ) {
        effectiveness -= 1;
      }
    });

    return effectiveness.toString();
  },
  multiply: function( effectiveness ) { 
    switch(effectiveness) {
      case '-2':
        return '0.51';
        break;
      
      case '-1':
        return '0.714';
        break;
      
      case '1':
        return '1.4';
        break;
      
      case '2':
        return '1.96';
        break;
      
      default:
        return '—';
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/typeEff.js